const GET_FEE_DATA_START = 'GET_FEE_DATA_START';
const GET_FEE_DATA_SUCCESS = 'GET_FEE_DATA_SUCCESS';
const GET_FEE_DATA_ERROR = 'GET_FEE_DATA_ERROR';

const GET_TOS_DATA = 'GET_TOS_DATA';
const GET_TOS_DATA_SUCCESS = 'GET_TOS_DATA_SUCCESS';
const GET_TOS_DATA_ERROR = 'GET_TOS_DATA_ERROR';


const getfeeStart = () => {
	return {
		type: GET_FEE_DATA_START,
	};
};

const getfeeSuccess = (res) => {
	return {
		type: GET_FEE_DATA_SUCCESS,
		res
	};
};

const getfeeError = () => {
	return {
		type: GET_FEE_DATA_ERROR,
	};
};

const getTOSData = () => {
	console.log('ACTIOM COMM TOS ::');
	return {
		type: GET_TOS_DATA,
	};
};

const getTOSDataSuccess = (res) => {
	return {
		type: GET_TOS_DATA_SUCCESS,
		res
	};
};

const getTOSDataError = () => {
	return {
		type: GET_TOS_DATA_ERROR,
	};
};


export default {
	types: {
		GET_FEE_DATA_START,
		GET_FEE_DATA_SUCCESS,
		GET_FEE_DATA_ERROR,
		GET_TOS_DATA,
		GET_TOS_DATA_SUCCESS,
		GET_TOS_DATA_ERROR,
	},
	creators: {
		getfeeStart,
		getfeeSuccess,
		getfeeError,
		getTOSData,
		getTOSDataSuccess,
		getTOSDataError
	},
};
